// Vietnamese friendly names for Vietmap layer IDs.
// Used in the in-map popup and the Layer Editor header.

const LAYER_PATTERNS: Array<{pattern: RegExp; name: string}> = [
  // Background / terrain
  { pattern: /^background$/, name: "Nền bản đồ" },
  { pattern: /^ocean_planet$/, name: "Biển / Đại dương" },
  { pattern: /^island/, name: "Đảo" },
  { pattern: /^water_polygon/, name: "Mặt nước" },
  { pattern: /^water_line/, name: "Sông / Suối" },
  { pattern: /^water_point/, name: "Nguồn nước" },
  { pattern: /^landcover_wood/, name: "Rừng / Cây xanh" },
  { pattern: /^landcover_park/, name: "Công viên (thảm phủ)" },
  { pattern: /^landcover_grass/, name: "Thảm cỏ" },
  { pattern: /^landuse_residential/, name: "Khu dân cư" },
  { pattern: /^landuse_cemetery/, name: "Nghĩa trang" },
  { pattern: /^landuse_hospital/, name: "Bệnh viện (khu vực)" },
  { pattern: /^landuse_school/, name: "Trường học (khu vực)" },
  { pattern: /^landuse_theme_park/, name: "Công viên giải trí" },
  { pattern: /^aeroway/, name: "Đường băng sân bay" },
  { pattern: /^building$/, name: "Tòa nhà" },

  // Roads – tunnel
  { pattern: /^tunnel_motorway/, name: "Đường hầm cao tốc" },
  { pattern: /^tunnel_trunk/, name: "Đường hầm quốc lộ" },
  { pattern: /^tunnel_primary/, name: "Đường hầm đường chính" },
  { pattern: /^tunnel_secondary/, name: "Đường hầm đường phụ" },
  { pattern: /^tunnel_tertiary/, name: "Đường hầm đường nhánh" },
  { pattern: /^tunnel_minor/, name: "Đường hầm đường nhỏ" },
  { pattern: /^tunnel_path/, name: "Đường hầm bộ hành" },

  // Roads – bridge
  { pattern: /^bridge_motorway/, name: "Cầu cao tốc" },
  { pattern: /^bridge_trunk/, name: "Cầu quốc lộ" },
  { pattern: /^bridge_primary/, name: "Cầu đường chính" },
  { pattern: /^bridge_secondary/, name: "Cầu đường phụ" },
  { pattern: /^bridge_tertiary/, name: "Cầu đường nhánh" },
  { pattern: /^bridge_minor/, name: "Cầu đường nhỏ" },
  { pattern: /^bridge_path/, name: "Cầu bộ hành" },

  // Roads – surface
  { pattern: /^road_ferry/, name: "Tuyến phà" },
  { pattern: /road_motorway_construction|road_construction/, name: "Đường đang thi công" },
  { pattern: /^road_motorway/, name: "Đường cao tốc" },
  { pattern: /^road_trunk/, name: "Quốc lộ" },
  { pattern: /^road_primary/, name: "Đường chính" },
  { pattern: /^road_secondary/, name: "Đường phụ" },
  { pattern: /^road_tertiary/, name: "Đường nhánh" },
  { pattern: /^road_minor/, name: "Đường nhỏ" },
  { pattern: /^road_path/, name: "Đường bộ / Đi bộ" },
  { pattern: /^road_rail/, name: "Đường sắt / Metro" },

  // Road labels
  { pattern: /^road_motorway_shield|^road_shield/, name: "Biển số đường" },
  { pattern: /^road_motorway_label/, name: "Tên cao tốc" },
  { pattern: /^road_trunk_label/, name: "Tên quốc lộ" },
  { pattern: /^road_primary_label/, name: "Tên đường chính" },
  { pattern: /^road_secondary_label/, name: "Tên đường phụ" },
  { pattern: /^road_tertiary_label/, name: "Tên đường nhánh" },
  { pattern: /^road_minor_label/, name: "Tên đường nhỏ" },
  { pattern: /^road_path_label|^road_ferry_label/, name: "Tên đường bộ / Phà" },

  // Places
  { pattern: /^country_VN$/, name: "Tên Việt Nam" },
  { pattern: /^country_/, name: "Tên quốc gia" },
  { pattern: /^place_Hanoi$/, name: "Hà Nội" },
  { pattern: /^place_capital/, name: "Thủ đô" },
  { pattern: /^place_state|^place_province/, name: "Tên tỉnh / Thành phố" },
  { pattern: /^place_city/, name: "Tên thành phố" },
  { pattern: /^place_town/, name: "Tên thị trấn" },
  { pattern: /^place_island/, name: "Tên đảo" },
  { pattern: /^place_TS_HS/, name: "Trường Sa / Hoàng Sa" },
  { pattern: /^boundary_district/, name: "Ranh giới quận / huyện" },
  { pattern: /^boundary_province/, name: "Ranh giới tỉnh / thành" },
  { pattern: /^boundary_2_label/, name: "Ranh giới quốc gia" },

  // POI
  { pattern: /^water_point/, name: "Nguồn nước" },
  { pattern: /^poiz\d+_vietmap$/, name: "Vietmap" },
  { pattern: /^poiz\d+_airport$/, name: "Sân bay" },
  { pattern: /^poiz\d+_rail|^poiz\d+_harbor/, name: "Ga tàu / Bến cảng" },
  { pattern: /^poiz\d+_bus/, name: "Bến xe buýt" },
  { pattern: /^poiz\d+_parking/, name: "Bãi đậu xe" },
  { pattern: /^poiz\d+_gasstation/, name: "Cây xăng" },
  { pattern: /^poiz\d+_chargingstation/, name: "Trạm sạc điện" },
  { pattern: /^poiz\d+_reststop/, name: "Trạm dừng nghỉ" },
  { pattern: /^poiz\d+_hospital$/, name: "Bệnh viện" },
  { pattern: /^poiz\d+_pharmacy/, name: "Nhà thuốc / Y tế" },
  { pattern: /^poiz\d+_clinic/, name: "Phòng khám" },
  { pattern: /^poiz\d+_hotel/, name: "Khách sạn" },
  { pattern: /^poiz\d+_resort/, name: "Resort / Nhà nghỉ" },
  { pattern: /^poiz\d+_bank/, name: "Ngân hàng / Tài chính" },
  { pattern: /^poiz\d+_atm/, name: "Cây ATM" },
  { pattern: /^poiz\d+_supermarket/, name: "Siêu thị / Trung tâm TM" },
  { pattern: /^poiz\d+_store/, name: "Cửa hàng" },
  { pattern: /^poiz\d+_restaurant$/, name: "Nhà hàng" },
  { pattern: /^poiz\d+_bbq/, name: "Nhà hàng BBQ" },
  { pattern: /^poiz\d+_fastfood/, name: "Đồ ăn nhanh" },
  { pattern: /^poiz\d+_vietnamfood/, name: "Ẩm thực Việt Nam" },
  { pattern: /^poiz\d+_cafe/, name: "Cà phê" },
  { pattern: /^poiz\d+_beer|^poiz\d+_barclub/, name: "Quán bia / Bar" },
  { pattern: /^poiz\d+_education/, name: "Trường học / Giáo dục" },
  { pattern: /^poiz\d+_museum/, name: "Bảo tàng" },
  { pattern: /^poiz\d+_cinema/, name: "Rạp chiếu phim" },
  { pattern: /^poiz\d+_theatre/, name: "Nhà hát" },
  { pattern: /^poiz\d+_casino/, name: "Casino" },
  { pattern: /^poiz\d+_gym/, name: "Phòng gym / Thể dục" },
  { pattern: /^poiz\d+_football/, name: "Sân bóng đá" },
  { pattern: /^poiz\d+_swimming/, name: "Bể bơi" },
  { pattern: /^poiz\d+_tennis/, name: "Sân tennis" },
  { pattern: /^poiz\d+_golf/, name: "Sân golf" },
  { pattern: /^poiz\d+_beach/, name: "Bãi biển" },
  { pattern: /^poiz\d+_arena/, name: "Sân vận động" },
  { pattern: /^poiz\d+_zoo/, name: "Vườn thú" },
  { pattern: /^poiz\d+_amusement/, name: "Công viên giải trí" },
  { pattern: /^poiz\d+_studio/, name: "Studio / Nhiếp ảnh" },
  { pattern: /^poiz\d+_book/, name: "Nhà sách / Thư viện" },
  { pattern: /^poiz\d+_memorial/, name: "Tượng đài / Di tích" },
  { pattern: /^poiz\d+_pagoda/, name: "Chùa / Đền / Thánh đường" },
  { pattern: /^poiz\d+_church/, name: "Nhà thờ" },
  { pattern: /^poiz\d+_police/, name: "Công an / Cơ quan nhà nước" },
  { pattern: /^poiz\d+_fire/, name: "Cứu hỏa" },
  { pattern: /^poiz\d+_committee/, name: "Ủy ban / Tòa thị chính" },
  { pattern: /^poiz\d+_company/, name: "Công ty / Văn phòng" },
  { pattern: /^poiz\d+_building/, name: "Tòa nhà / Bưu điện" },
  { pattern: /^poiz\d+_attraction/, name: "Điểm tham quan / Du lịch" },
  { pattern: /^poiz\d+_industrial/, name: "Khu công nghiệp" },
  { pattern: /^poiz\d+_cemetery/, name: "Nghĩa trang" },
  { pattern: /^poiz\d+_border/, name: "Cửa khẩu / Biên giới" },
  { pattern: /^poiz\d+_park$/, name: "Công viên" },
  { pattern: /^park_label/, name: "Khu bảo tồn / Vườn quốc gia" },
  { pattern: /^poiz\d+_other/, name: "Địa điểm khác" },
];

const SOURCE_LAYER_NAMES: Record<string, string> = {
  road: "🛣️ Đường",
  poi: "📍 Địa điểm",
  building: "🏢 Tòa nhà",
  water: "💧 Nước",
  waterway: "🌊 Sông ngòi",
  landuse: "🗺️ Sử dụng đất",
  place: "🏙️ Địa danh",
  admin_point: "📌 Điểm hành chính",
  admin_line: "📏 Ranh giới",
  island: "🏝️ Đảo",
  railway: "🚆 Đường sắt",
};

const LAYER_TYPE_VI: Record<string, string> = {
  background: "Nền",
  fill: "Vùng",
  "fill-extrusion": "Khối 3D",
  line: "Đường",
  symbol: "Nhãn / Icon",
  circle: "Điểm",
  heatmap: "Heatmap",
  raster: "Ảnh raster",
  hillshade: "Đổ bóng địa hình",
};

/**
 * Strip Vietnamese diacritics + lowercase for accent-insensitive search.
 *   "Đường nhỏ" → "duong nho"
 *   "Mặt nước"  → "mat nuoc"
 *
 * Uses NFD normalisation + diacritic regex (Unicode prop class). Handles the
 * Vietnamese `đ`/`Đ` specifically since they decompose to "d" + a stroke
 * combining mark which `\p{Diacritic}` doesn't always catch.
 */
export function normalizeVi(input: string): string {
  if (!input) return "";
  return input
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // combining marks (accents)
    .replace(/đ/g, "d")
    .replace(/Đ/g, "d")
    .toLowerCase()
    .trim();
}

/**
 * Does `haystack` contain `needle` ignoring case AND Vietnamese diacritics?
 * Empty needle → always true (no filter).
 */
export function matchesVi(haystack: string, needle: string): boolean {
  const n = normalizeVi(needle);
  if (!n) return true;
  return normalizeVi(haystack).includes(n);
}

/**
 * Name to show for a layer: an explicit `maputnik:display_name` (e.g. data
 * layers added from MapZone) wins over the id-based Vietnamese name.
 */
export function layerDisplayName(layer: { id: string; metadata?: unknown }): string {
  const name = (layer.metadata as Record<string, unknown> | undefined)?.["maputnik:display_name"];
  return typeof name === "string" && name ? name : getVietnameseLayerName(layer.id);
}

export function getVietnameseLayerName(layerId: string): string {
  for (const {pattern, name} of LAYER_PATTERNS) {
    if (pattern.test(layerId)) return name;
  }
  return layerId;
}

export function getSourceLayerLabel(srcLayer: string): string {
  return SOURCE_LAYER_NAMES[srcLayer] || srcLayer;
}

export function getLayerTypeVi(type: string): string {
  return LAYER_TYPE_VI[type] || type;
}

// ─── Protected layers (cannot be hidden) ─────────────────────────────────────
// Trường Sa / Hoàng Sa layers represent Vietnamese sovereignty over the islands
// and must never be hideable — by user request.
const PROTECTED_LAYER_PATTERNS: RegExp[] = [
  /^place_TS_HS/,
];

// Translation key used by ProtectedAlert.tsx. Localised at render time.
export const PROTECTED_HIDE_MESSAGE =
  "Quần đảo Hoàng Sa, Trường Sa thuộc về Việt Nam, không cho phép ẩn 2 quần đảo này với bất kì lý do nào, dưới bất kì hình thức gì.";

export function isProtectedLayer(layerId: string): boolean {
  return PROTECTED_LAYER_PATTERNS.some(p => p.test(layerId));
}

/**
 * Open the in-app protected-layer modal and return true if the layer is
 * protected (so the caller should bail out). Returns false for normal layers —
 * caller should proceed with the hide.
 */
export function guardProtectedHide(layerId: string): boolean {
  if (!isProtectedLayer(layerId)) return false;
  // Lazy import keeps this libs/ module free of React deps.
  import("./protected-alert").then(m => m.openProtectedAlert());
  return true;
}
